export const environment = {
    production: false,
    environment: 'dev',

    // new authentication config
    cognito: {
        userPoolId: 'eu-west-1_Ab8XQA3n7',
        userPoolClientId: '1bpapjcf5hl5o4j36trhvj088l',
        //identityPoolId: 'eu-west-1_Ab8XQA3n7',
        domain: 'fastlanedev.auth.eu-west-1.amazoncognito.com',
        redirectSignIn: 'https://fastlane-dev.icadsistemi.com/home',
        redirectSignOut: 'https://fastlane-dev.icadsistemi.com'
    },

    datadog: {
        GILB_NEW_DC: {
            service: ['DataCollection-Staging', 'DataCollectionServer-Staging', 'is-controller-Staging'],
            env: '',
            vendor: 'gilbarco',
        },
        GILB_OLD_DC: {
            service: ['isOverviewDirect', 'isOverviewDaemon', 'Overview.GVRPPRC'],
            env: 'dev',
            vendor: 'gilbarco',
        },
        DRES: {
            service: ['DataCollection-Staging', 'DataCollectionServer-Staging', 'is-controller-Staging'],
            env: '',
            vendor: 'wayne'
        },
        TOK: {
            service: ['isOverviewDaemon', 'isOverviewConnect'],
            env: '',
            vendor: 'tokheim'
        },
        '4TS': {
            service: ['isOverviewDaemon', 'isOverviewDirect'],
            env: '',
            vendor: ''
        },
        MASER: {
            service: ['datacollection_maser-production', 'DataCollectionServer-Staging'],
            env: '',
            vendor: ''
        },
        'GL+': {
            service: ['is.service.datacollection.glplus'],
            env: 'dev',
            vendor: ''
        },
        Monitoring: {
            service: ['is.service.dc.monitor',],
            env: 'dev',
            vendor: '',
        },
    },

    // Micro Services.
    modInsightUrl: 'https://mxp-fastlane-api.dev.icadsistemi.com/modinsight/api/v1/',
    modMikrotikUrl: 'https://mxp-dev-fastlane-api.icadsistemi.com/modmikrotik/api/v1/',
    modPrometheusUrl: 'https://mxp-dev-fastlane-api.icadsistemi.com/modprometheus/api/v1/',
    modSyncRadiusUrl: 'https://mxp-dev-fastlane-api.icadsistemi.com/modsyncradius/api/v1/',
    modDataCollectionUrl: 'https://mxp-dev-fastlane-api.icadsistemi.com/moddatacollection/api/v1/',

    documentationUrls: ['https://icadsistemi.atlassian.net/wiki/spaces/IS/pages/552501702/FastLane'],

    // WebAPI Core.
    assistanceUrl: 'https://ws-selfnet-fastlane-dev.icadsistemi.com/api',

    // Lambda base url
    lambdaFastlaneBaseUrl: 'https://mxp-internal-api.dev.icadsistemi.com/v1/fastlane/',
    //lambdaBaseUrl: 'https://mxp-internal-api.dev.icadsistemi.com/v1',
    newlambdaBaseUrl: 'https://mxp-fastlane-api.dev.icadsistemi.com/v2/',
    newprodlambdaBaseUrl: 'https://mxp-fastlane-api.prod.icadsistemi.com/v2/',

    // Lambda thales base url
    lambdaThalesInternalUrl: 'https://mxp-internal-thales-api.dev.icadsistemi.com/v1/',

    // documentation base url
    documentationBaseUrl: 'https://mxp-internal-api.dev.icadsistemi.com/v1/documentation',

    //portal base url
    portalBaseUrl: 'https://services-stag.icadsistemi.com',

    // Settings.
    canLogConsole: true,
    simulateRoles: null,
    staging: true,
};
